<ng-container *ngIf="trashLength; else noArchivedTracks">
  <div class="table-outline" [style.max-height.px]="getTableHeight()" #table>
    <ng-container *ngIf="(archivedTracksObservable$ | async).length; else searchEmpty">
      <div class="table-head">
        <div
          class="header flex items-center"
          rkSort
          [(predicate)]="predicate"
          [(ascending)]="reverse"
          [callback]="transition.bind(this)"
        >
          <div class="default checkbox">
            <mat-checkbox
              (change)="toggleAll($event)"
              [checked]="
                (archivedTracksObservable$ | async).length > 0 &&
                (numberArchivedTracksSelected$ | async) >=
                  completedArchivedTracksLength(archivedTracksObservable$ | async)
              "
              [indeterminate]="
                (archivedTracksObservable$ | async).length > 0 &&
                (numberArchivedTracksSelected$ | async) <
                  completedArchivedTracksLength(archivedTracksObservable$ | async) &&
                (numberArchivedTracksSelected$ | async) > 0
              "
            >
            </mat-checkbox>
          </div>
          <ng-container
            *ngIf="!(numberArchivedTracksSelected$ | async); else selectedActions"
          >
            <div rkSortBy="title" class="default title">
              <span translate>MEDIA.COLUMNS.TITLE</span> <span class="fa"></span>
            </div>
            <div rkSortBy="artist" class="default artist">
              <span translate>MEDIA.COLUMNS.ARTIST</span> <span class="fa"></span>
            </div>
            <div rkSortBy="album" *ngIf="columns.album" class="default album">
              <span translate>MEDIA.COLUMNS.ALBUM</span> <span class="fa"></span>
            </div>
            <div rkSortBy="year" *ngIf="columns.year" class="default year">
              <span translate>MEDIA.COLUMNS.YEAR</span> <span class="fa"></span>
            </div>
            <div rkSortBy="archivedAt" *ngIf="columns.addedDate" class="default added">
              <span translate>MEDIA.COLUMNS.ARCHIVED</span> <span class="fa"></span>
            </div>
            <div rkSortBy="timeSeconds" *ngIf="columns.duration" class="default duration">
              <span translate>MEDIA.COLUMNS.DURATION</span> <span class="fa"></span>
            </div>
            <div rkSortBy="bpm" *ngIf="columns.bpm" class="default bpm">
              <span>BPM</span> <span class="fa"></span>
            </div>
            <div rkSortBy="bitrate" *ngIf="columns.kbps" class="default bpm">
              <span>Kbps</span> <span class="fa"></span>
            </div>
          </ng-container>
          <ng-template #selectedActions>
            <span class="selected-count">{{
              'MEDIA.TABLE.TRACKS_SELECTED'
                | translate : { nb: numberArchivedTracksSelected$ | async }
            }}</span>
            <rk-button
              class="selected-button"
              (click)="restoreMultiple()"
              btnStyle="link"
              [style]="getMultiSelectButtonStyle()"
              [faIcon]="'fa-trash-restore'"
              [label]="'MEDIA.CONTEXT_MENU.RESTORE_ARCHIVED' | translate"
            >
            </rk-button>
            <rk-button
              class="selected-button"
              (click)="deleteMultiple()"
              btnStyle="linkDanger"
              [style]="getMultiSelectButtonStyle()"
              [faIcon]="'fa-trash'"
              [label]="'MEDIA.CONTEXT_MENU.DELETE_DEFINITELY' | translate"
            >
            </rk-button>
          </ng-template>
        </div>
      </div>

      <div class="body-array cdk-custom-container flex flex-1">
        <cdk-virtual-scroll-viewport
          itemSize="50"
          class="flex-1"
          minBufferPx="800"
          maxBufferPx="1000"
          (scroll)="onCloseContextMenu()"
        >
          <rk-trash-audio-line
            *cdkVirtualFor="
              let item of archivedTracksObservable$ | async;
              templateCacheSize: 60
            "
            (shiftClicked)="onSelectShiftLine($event)"
            [archivedTrack]="item"
            [columns]="columns"
            [contextMenu]="isMultiSelect(item.id) ? multiCtxMenu : ctxMenu"
            [isContextMenuOpen]="item.id === trackOpen?.id"
            [hasPaddingRight]="!hasScroll"
            [isPlaying]="isPlaying$ | async"
            [isLoaded]="(currentTrackPlaying$ | async)?.id === item.id"
          ></rk-trash-audio-line>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #searchEmpty>
  <div class="search-empty">
    <img src="/assets/search-empty.svg" alt="" />
    <div>
      {{ 'MEDIA.TRASH.SEARCH_EMPTY' | translate : { search: searchField$ | async } }}
    </div>
  </div>
</ng-template>

<ng-template #noArchivedTracks>
  <div class="box-empty">
    <img src="/assets/trash-empty.svg" />
    <div translate>MEDIA.TRASH.BOX_EMPTY</div>
  </div>
</ng-template>

<context-menu
  #ctxMenu
  (open)="onOpenContextMenu($event.item)"
  (close)="onCloseContextMenu()"
>
  <ng-template contextMenuItem let-track [passive]="true">
    <div class="context-header">
      <img [src]="track.cover" />
      <div class="flex flex-col">
        <div class="header-track">{{ track.title }}</div>
        <div class="header-artist">{{ track.artist }}</div>
      </div>
    </div>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem let-track (execute)="playTrack($event.item)">
    <mat-icon fontSet="fa" fontIcon="fa-play"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.PLAY</span>
    <rk-hotkeys-help-clue [hotkey]="'playPause'"></rk-hotkeys-help-clue>
  </ng-template>
  <ng-template contextMenuItem [divider]="true" [visible]="isNotLocked"></ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="restoreArchivedTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-trash-restore"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.RESTORE_ARCHIVED</span>
  </ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="deleteArchivedTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon class="danger" fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span class="danger" translate>MEDIA.CONTEXT_MENU.DELETE_DEFINITELY</span>
    <rk-hotkeys-help-clue [hotkey]="'delete'"></rk-hotkeys-help-clue>
  </ng-template>
</context-menu>

<context-menu
  #multiCtxMenu
  (open)="onOpenContextMenu($event.item)"
  (close)="onCloseContextMenu()"
>
  <ng-template contextMenuItem let-track [passive]="true">
    <div class="context-header">
      <div class="header-track">
        {{
          'MEDIA.TABLE.TRACKS_SELECTED'
            | translate : { nb: numberArchivedTracksSelected$ | async }
        }}
      </div>
    </div>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem (execute)="restoreMultiple()">
    <mat-icon fontSet="fa" fontIcon="fa-trash-restore"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.RESTORE_ARCHIVED</span>
  </ng-template>
  <ng-template contextMenuItem (execute)="deleteMultiple()">
    <mat-icon class="danger" fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span class="danger" translate>MEDIA.CONTEXT_MENU.DELETE_DEFINITELY</span>
    <rk-hotkeys-help-clue [hotkey]="'delete'"></rk-hotkeys-help-clue>
  </ng-template>
</context-menu>
